import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dpo');
import { formatWorkspaceDate } from "src/libs/portal/season/util/workspace-date";
import { OnInit, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

import { activateListRow } from "src/libs/portal/season/util/list-row";

@Component({
    selector: 'wiz-page-dpo',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dpo/view.scss */
:host {
  display: block;
}

.dpo {
  --dpo-canvas:var(--ui-canvas);
  --dpo-paper:var(--ui-paper);
  --dpo-soft:var(--ui-soft);
  --dpo-hover:var(--ui-hover);
  --dpo-selected:var(--ui-selected);
  --dpo-ink:var(--ui-ink);
  --dpo-text:var(--ui-text);
  --dpo-muted:var(--ui-muted);
  --dpo-line:var(--ui-line);
  --dpo-control:var(--ui-control);
  --dpo-accent:var(--ui-accent);
  --dpo-accent-hover:var(--ui-accent-hover);
  --dpo-dark:var(--ui-navy);
  --dpo-on-dark:var(--ui-on-navy);
  --dpo-muted-on-dark:color-mix(in srgb,var(--ui-on-navy) 78%,var(--ui-navy));
  --dpo-dark-line:color-mix(in srgb,var(--ui-on-navy) 25%,var(--ui-navy));
  --dpo-success:var(--ui-success);
  --dpo-success-soft:var(--ui-success-soft);
  --dpo-progress-on-dark:color-mix(in srgb,var(--ui-success) 45%,var(--ui-on-navy));
  --dpo-warning:var(--ui-warning);
  --dpo-warning-soft:color-mix(in srgb,var(--ui-warning) 12%,var(--ui-paper));
  --dpo-danger:var(--ui-danger);
  --dpo-danger-soft:color-mix(in srgb,var(--ui-danger) 12%,var(--ui-paper));
  box-sizing: border-box;
  min-height: 100dvh;
  padding: 24px 28px 40px;
  background: var(--dpo-canvas);
  color: var(--dpo-text);
  font-family: Pretendard, Inter, sans-serif;
  font-size: 14px;
  line-height: 1.55;
}
.dpo *, .dpo *::before, .dpo *::after {
  box-sizing: border-box;
}
.dpo h1, .dpo h2, .dpo h3, .dpo h4, .dpo p {
  margin: 0;
}
.dpo h1, .dpo h2, .dpo h3, .dpo h4 {
  color: var(--dpo-ink);
  font-weight: 650;
  letter-spacing: -0.025em;
}
.dpo h1 {
  font-size: 26px;
  line-height: 1.3;
}
.dpo h2 {
  font-size: 24px;
  line-height: 1.5;
}
.dpo h3 {
  font-size: 16px;
  line-height: 1.5;
}
.dpo button, .dpo input, .dpo select, .dpo textarea {
  font: inherit;
}
.dpo button, .dpo a, .dpo summary {
  touch-action: manipulation;
}
.dpo button {
  cursor: pointer;
}
.dpo button:disabled {
  cursor: default;
  opacity: 0.48;
}
.dpo a {
  color: var(--dpo-accent);
  text-underline-offset: 3px;
}
.dpo :is(button, a, summary, input, select, textarea, [tabindex]):focus-visible {
  outline: 2px solid var(--dpo-accent);
  outline-offset: 3px;
}
.dpo :is(h1, h2, h3, [tabindex]) {
  scroll-margin-top: calc(var(--workspace-header-height, 0px) + 18px);
}
.dpo ::selection {
  background: var(--dpo-selected);
  color: var(--dpo-ink);
}
.dpo input, .dpo select, .dpo textarea {
  width: 100%;
  min-width: 0;
  min-height: 40px;
  padding: 9px 12px;
  border: 1px solid var(--dpo-control);
  border-radius: 8px;
  background: var(--dpo-paper);
  color: var(--dpo-text);
  caret-color: var(--dpo-accent);
}
.dpo input::placeholder, .dpo textarea::placeholder {
  color: var(--dpo-muted);
  opacity: 1;
}
.dpo textarea {
  resize: vertical;
  line-height: 1.75;
}
.dpo input[readonly], .dpo textarea[readonly] {
  background: var(--dpo-soft);
  color: var(--dpo-muted);
}
.dpo label {
  display: block;
  margin: 14px 0 6px;
  font-weight: 600;
}
.dpo fieldset {
  min-width: 0;
  border: 0;
  padding: 0;
  margin: 0;
}
.dpo summary {
  cursor: pointer;
  min-height: 36px;
}
.dpo .button, .dpo .text-button, .dpo .icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  text-decoration: none;
  font-weight: 600;
  line-height: 1.4;
  color: var(--dpo-text);
  background: transparent;
}
.dpo .button {
  min-height: 40px;
  padding: 10px 16px;
  border-radius: 8px;
}
.dpo .button.primary {
  background: var(--dpo-accent);
  color: var(--dpo-on-dark);
}
.dpo .button.primary:hover:not(:disabled) {
  background: var(--dpo-accent-hover);
}
.dpo .button.secondary {
  background: var(--dpo-soft);
  color: var(--dpo-ink);
}
.dpo .button.secondary:hover:not(:disabled) {
  background: var(--dpo-hover);
}
.dpo .text-button {
  min-height: 36px;
  padding: 6px 4px;
  font-size: 13px;
  color: var(--dpo-accent);
}
.dpo .text-button:hover:not(:disabled) {
  color: var(--dpo-accent-hover);
  text-decoration: underline;
  text-underline-offset: 4px;
}
.dpo .icon-button {
  min-width: 36px;
  min-height: 36px;
  padding: 7px;
  border-radius: 7px;
}
.dpo .icon-button:hover:not(:disabled) {
  background: var(--dpo-soft);
}
.dpo .required, .dpo .optional {
  font-size: 12px;
  font-weight: 400;
  color: var(--dpo-muted);
  margin-left: 4px;
}
.dpo .required {
  color: var(--dpo-danger);
}
.dpo .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.dpo .dpo-header {
  display: flex;
  align-items: center;
  gap: 24px;
  min-height: 48px;
  margin-bottom: 28px;
}
.dpo .dpo-header > h1 {
  flex: 0 0 auto;
}
.dpo .mode-switch {
  display: flex;
  gap: 2px;
  align-items: center;
  padding: 3px;
  border: 1px solid var(--dpo-line);
  border-radius: 9px;
  background: var(--dpo-soft);
}
.dpo .mode-switch > button {
  min-height: 36px;
  padding: 7px 18px;
  border: 0;
  border-radius: 6px;
  background: none;
  color: var(--dpo-muted);
  font-weight: 600;
  transition: background-color 0.16s ease, color 0.16s ease;
}
.dpo .mode-switch > button.active {
  background: var(--dpo-dark);
  color: var(--dpo-on-dark);
}
.dpo .mode-switch > button:not(.active):hover {
  color: var(--dpo-ink);
  background: var(--dpo-hover);
}
.dpo .header-progress {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  white-space: nowrap;
  color: var(--dpo-muted);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}
.dpo .header-progress strong {
  color: var(--dpo-ink);
  font-size: 14px;
}
.dpo progress {
  display: block;
  appearance: none;
  width: 100%;
  height: 6px;
  border: 0;
  border-radius: 20px;
  overflow: hidden;
  background: var(--dpo-line);
}
.dpo progress::-webkit-progress-bar {
  background: var(--dpo-line);
}
.dpo progress::-webkit-progress-value {
  background: var(--dpo-success);
  border-radius: 20px;
}
.dpo progress::-moz-progress-bar {
  background: var(--dpo-success);
}
.dpo .header-progress progress {
  width: 88px;
  height: 4px;
}
.dpo .session-panel #start-review:focus-visible {
  outline-color: var(--ui-nav-focus);
}
.dpo .session-panel {
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(280px, 1fr);
  gap: 48px;
  align-items: center;
  padding: 28px 32px;
  background: var(--dpo-dark);
  border-radius: 16px;
  color: var(--dpo-on-dark);
}
.dpo .session-intro h2 {
  max-width: 22ch;
  font-size: 26px;
  line-height: 1.45;
  color: var(--dpo-on-dark);
  font-weight: 650;
  word-break: keep-all;
}
.dpo .session-intro > p {
  max-width: 43ch;
  margin-top: 14px;
  color: var(--dpo-muted-on-dark);
  line-height: 1.8;
  word-break: keep-all;
}
.dpo .session-action {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 20px;
}
.dpo .session-action .button {
  min-height: 48px;
  padding: 13px 20px;
}
.dpo .session-action .button.primary {
  background: var(--dpo-accent);
  color: var(--dpo-on-dark);
}
.dpo .session-action .button.primary:hover:not(:disabled) {
  background: var(--dpo-accent-hover);
}
.dpo .session-action > span {
  font-size: 12px;
  color: var(--dpo-muted-on-dark);
}
.dpo .session-progress {
  padding: 8px 0 8px 32px;
  border-left: 1px solid var(--dpo-dark-line);
}
.dpo .progress-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}
.dpo .progress-heading h3 {
  color: var(--dpo-muted-on-dark);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
}
.dpo .progress-heading > strong {
  font-size: 32px;
  color: var(--dpo-on-dark);
  font-weight: 600;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}
.dpo .progress-heading > strong > span {
  font-size: 16px;
  margin-left: 3px;
}
.dpo .session-progress progress {
  height: 7px;
  background: var(--dpo-dark-line);
}
.dpo .session-progress progress::-webkit-progress-bar {
  background: var(--dpo-dark-line);
}
.dpo .session-progress progress::-webkit-progress-value {
  background: var(--dpo-progress-on-dark);
}
.dpo .session-progress progress::-moz-progress-bar {
  background: var(--dpo-progress-on-dark);
}
.dpo .session-counts {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr;
  gap: 16px;
  margin: 22px 0 0;
}
.dpo .session-counts dt {
  color: var(--dpo-muted-on-dark);
  font-size: 12px;
}
.dpo .session-counts dd {
  margin: 6px 0 0;
  color: var(--dpo-on-dark);
  font-size: 20px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.dpo .session-counts dd > span {
  font-size: 12px;
  color: var(--dpo-muted-on-dark);
  font-weight: 400;
  white-space: nowrap;
}
.dpo .home-details {
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(280px, 1fr);
  gap: 48px;
  padding: 30px 10px 0;
}
.dpo .next-preview {
  padding-right: 24px;
}
.dpo .next-preview h3, .dpo .home-guide > h3 {
  font-size: 14px;
  letter-spacing: 0;
  color: var(--dpo-muted);
}
.dpo .next-preview > p {
  font-size: 21px;
  font-weight: 600;
  line-height: 1.65;
  letter-spacing: -0.025em;
  color: var(--dpo-ink);
  margin: 16px 0 12px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: keep-all;
  overflow-wrap: anywhere;
}
.dpo .next-preview > span {
  display: block;
  font-size: 13px;
  color: var(--dpo-muted);
  overflow-wrap: anywhere;
}
.dpo .home-guide ol {
  list-style: none;
  padding: 0;
  margin: 12px 0 8px;
}
.dpo .home-guide li {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  gap: 10px;
  padding: 8px 0;
  font-size: 13px;
}
.dpo .home-guide li > strong {
  color: var(--dpo-ink);
  font-weight: 600;
}
.dpo .home-guide li > span {
  color: var(--dpo-muted);
}
.dpo .home-guide details {
  margin-top: 12px;
  padding-top: 6px;
  border-top: 1px solid var(--dpo-line);
  font-size: 13px;
  color: var(--dpo-muted);
}
.dpo .home-guide details p {
  line-height: 1.8;
  padding: 8px 0;
}
.dpo .comparison {
  min-width: 0;
}
.dpo .question {
  padding: 0 2px 20px;
}
.dpo .question h2 {
  max-width: 82ch;
  font-size: 24px;
  line-height: 1.6;
  word-break: keep-all;
  overflow-wrap: anywhere;
}
.dpo .evidence-access {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-top: 12px;
}
.dpo .question-source {
  flex: 1 1 280px;
  min-width: 0;
  font-size: 13px;
  color: var(--dpo-muted);
  overflow-wrap: anywhere;
}
.dpo #evidence-toggle {
  padding: 8px 12px;
  background: var(--dpo-soft);
  color: var(--dpo-ink);
  border-radius: 7px;
  min-height: 36px;
  flex-shrink: 0;
  text-decoration: none;
}
.dpo #evidence-toggle:hover:not(:disabled), .dpo #evidence-toggle[aria-expanded=true] {
  background: var(--dpo-selected);
}
.dpo .review-context-disclosure {
  font-size: 13px;
}
.dpo .review-context-disclosure > summary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  list-style: none;
}
.dpo .review-context-disclosure > summary::-webkit-details-marker {
  display: none;
}
.dpo .review-context {
  width: 100%;
  padding: 12px;
  background: var(--dpo-warning-soft);
  color: var(--dpo-warning);
  border-radius: 8px;
  line-height: 1.75;
}
.dpo .review-context-disclosure[open] {
  flex-basis: 100%;
}
.dpo .review-context ul {
  margin: 4px 0;
  padding-left: 20px;
}
.dpo .review-badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 3px 8px;
  border-radius: 5px;
  background: var(--dpo-warning-soft);
  color: var(--dpo-warning);
  font-size: 12px;
  font-weight: 600;
}
.dpo .reader-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
  gap: 20px;
}
.dpo .reader-layout.evidence-open {
  grid-template-columns: minmax(0, 1fr) minmax(300px, 29%);
}
.dpo .review-primary {
  grid-column: 1;
  grid-row: 1;
  min-width: 0;
}
.dpo .reference-pane {
  grid-column: 2;
  grid-row: 1;
  position: sticky;
  top: 20px;
  max-height: calc(100dvh - 44px);
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--dpo-control) var(--dpo-soft);
}
.dpo .responses {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1px;
  overflow: hidden;
  border: 1px solid var(--dpo-line);
  border-radius: 14px;
  background: var(--dpo-line);
}
.dpo .response {
  min-width: 0;
  background: var(--dpo-paper);
  transition: background-color 0.16s ease;
}
.dpo .response > header {
  background: var(--dpo-soft);
  border-bottom: 1px solid var(--dpo-line);
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  transition: background-color 0.16s ease;
}
.dpo .response h3 {
  width: 100%;
  font-size: 16px;
  color: var(--dpo-ink);
}
.dpo .response h3:has(> ng-container) {
  padding: 14px 20px;
}
.dpo .response:not(.card-selectable) h3 {
  padding: 14px 20px;
}
.dpo .card-choice {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 58px;
  padding: 15px 20px;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
}
.dpo .card-choice:disabled {
  opacity: 1;
}
.dpo .response-title {
  font-size: 16px;
  font-weight: 650;
  white-space: nowrap;
}
.dpo .response-select-hint {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  color: var(--dpo-muted);
  font-weight: 500;
  white-space: nowrap;
}
.dpo .response-select-hint i {
  transition: transform 0.16s ease;
}
.dpo .response-body {
  padding: 22px;
  min-height: 0;
  max-height: min(58dvh, 660px);
  overflow: auto;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 17px;
  line-height: 1.9;
  color: var(--dpo-text);
  scrollbar-width: thin;
  scrollbar-color: var(--dpo-control) var(--dpo-soft);
  cursor: text;
}
.dpo .response.card-selectable {
  cursor: pointer;
}
.dpo .response.selectable:focus-within {
  background: var(--dpo-selected);
}
.dpo .response.selectable:focus-within > header, .dpo .response.chosen > header {
  background: var(--dpo-accent);
  border-bottom-color: var(--dpo-accent);
}
.dpo .response.selectable:focus-within :is(.card-choice, .response-select-hint), .dpo .response.chosen :is(h3, .card-choice, .response-select-hint, .chosen-label) {
  color: var(--dpo-on-dark);
}
.dpo .chosen-label {
  padding: 8px 16px;
  white-space: nowrap;
  font-size: 12px;
  color: var(--dpo-accent);
}
.dpo .model {
  font-size: 12px;
  padding: 8px 20px;
  color: var(--dpo-muted);
  background: var(--dpo-soft);
}
.dpo .decision-bar {
  margin-top: 14px;
  padding: 12px 4px 6px;
  border-top: 1px solid var(--dpo-line);
}
.dpo .decision-intro {
  margin-bottom: 8px;
  color: var(--dpo-muted);
  font-size: 12px;
  min-height: 19px;
}
.dpo .decision-intro.quiet-instruction {
  display: none;
}
.dpo .evaluation-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.dpo .evaluation-toolbar > #memo-toggle {
  order: 2;
  margin-left: auto;
}
.dpo .decision-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dpo .decision-actions .button {
  border: 1px solid var(--dpo-line);
  background: var(--dpo-soft);
  color: var(--dpo-ink);
}
.dpo .decision-actions .button:hover:not(:disabled) {
  background: var(--dpo-hover);
  border-color: var(--dpo-accent);
}
.dpo .reason-section {
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr);
  gap: 8px 18px;
  padding: 18px 0 8px;
  margin-top: 12px;
  border-top: 1px solid var(--dpo-line);
}
.dpo .evaluation-reason-select {
  grid-column: 1;
  grid-row: 1/4;
}
.dpo .reason-section > label {
  grid-column: 2;
  margin: 0;
}
.dpo .evaluation-reason-select > label {
  margin: 0 0 6px;
}
.dpo .reason-section > textarea {
  grid-column: 2;
  font-size: 14px;
}
.dpo .memo-save, .dpo .reason-limit {
  grid-column: 2;
  justify-self: end;
}
.dpo .reason-limit {
  color: var(--dpo-danger);
  font-size: 12px;
}
.dpo .hold-reasons {
  padding: 12px 14px;
  background: var(--dpo-soft);
  border-radius: 10px;
}
.dpo .hold-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}
.dpo .hold-heading > strong {
  font-size: 14px;
  color: var(--dpo-ink);
}
.dpo .hold-other-actions {
  display: flex;
  gap: 16px;
}
.dpo .hold-reason-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.dpo .hold-reason-actions .button {
  background: var(--dpo-paper);
}
.dpo .evidence-panel {
  background: var(--dpo-soft);
  border: 1px solid var(--dpo-line);
  border-radius: 12px;
  padding: 0 16px 16px;
  font-size: 13px;
  line-height: 1.75;
}
.dpo .evidence-heading {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 0 -16px 12px;
  padding: 10px 14px;
  background: var(--dpo-soft);
  border-bottom: 1px solid var(--dpo-line);
  z-index: 1;
}
.dpo .evidence-heading h3 {
  font-size: 15px;
}
.dpo .evidence-source-name {
  font-size: 12px;
  color: var(--dpo-muted);
  margin-bottom: 12px;
  overflow-wrap: anywhere;
}
.dpo .evidence-originals {
  display: grid;
  gap: 8px;
  margin: 12px 0;
  font-size: 12px;
}
.dpo .evidence-originals a {
  display: inline;
  color: var(--dpo-accent);
  font-weight: 600;
}
.dpo .evidence-originals small {
  display: block;
  color: var(--dpo-muted);
}
.dpo .evidence-block {
  margin-top: 16px;
}
.dpo .evidence-source {
  font-weight: 600;
  margin-bottom: 8px;
}
.dpo .evidence-quote {
  margin: 0;
  padding: 14px;
  background: var(--dpo-paper);
  border-radius: 8px;
  color: var(--dpo-text);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 15px;
  line-height: 1.85;
}
.dpo .evidence-context {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 14px;
  line-height: 1.85;
  padding-top: 10px;
}
.dpo .evidence-context-links, .dpo .raw-evidence {
  margin-top: 10px;
}
.dpo .raw-evidence > p, .dpo .supplement-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  margin-top: 8px;
}
.dpo .supplemental-evidence {
  border-block: 1px solid var(--dpo-line);
  padding: 12px 0;
  margin: 12px 0;
}
.dpo .supplemental-evidence h4 {
  font-size: 14px;
  margin-bottom: 6px;
}
.dpo .supplement-help, .dpo .source-review-note {
  color: var(--dpo-muted);
}
.dpo .supplement-item {
  padding: 4px 0;
}
.dpo .item-tools {
  margin-top: 12px;
  border-top: 1px solid var(--dpo-line);
  font-size: 13px;
}
.dpo .item-tools > summary {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  list-style: none;
  color: var(--dpo-muted);
}
.dpo .item-tools > summary::-webkit-details-marker {
  display: none;
}
.dpo .item-tools > summary > i {
  margin-left: auto;
}
.dpo .item-tools[open] > summary > i {
  transform: rotate(180deg);
}
.dpo .record-count {
  font-size: 12px;
}
.dpo .item-record-body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(220px, 0.65fr);
  gap: 16px 24px;
  padding: 12px 0;
}
.dpo .reset-choice {
  grid-column: 1/-1;
  justify-self: end;
  color: var(--dpo-muted);
}
.dpo .item-history {
  min-width: 0;
}
.dpo .item-history ol {
  list-style: none;
  margin: 0;
  padding: 0;
}
.dpo .item-history li {
  padding: 12px 0;
  border-bottom: 1px solid var(--dpo-line);
}
.dpo .record-event-heading, .dpo .record-event-meta {
  display: flex;
  align-items: baseline;
  gap: 12px;
  flex-wrap: wrap;
}
.dpo .record-event-heading strong {
  color: var(--dpo-ink);
  font-size: 14px;
}
.dpo .record-version, .dpo .record-event-meta {
  color: var(--dpo-muted);
  font-size: 12px;
}
.dpo .record-reason {
  margin-top: 6px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.dpo .record-evaluation-detail {
  margin-top: 4px;
  font-size: 12px;
}
.dpo .item-registration {
  align-self: start;
  padding: 10px 14px;
  background: var(--dpo-soft);
  border-radius: 8px;
}
.dpo .item-registration > summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-weight: 600;
}
.dpo .record-metadata {
  margin: 8px 0;
  font-size: 12px;
}
.dpo .record-metadata > div {
  margin-bottom: 8px;
}
.dpo .record-metadata dt {
  color: var(--dpo-muted);
}
.dpo .record-metadata dd {
  margin: 2px 0;
  overflow-wrap: anywhere;
}
.dpo .record-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.dpo .personal-results {
  padding-bottom: 16px;
}
.dpo .results-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 22px;
}
.dpo .results-heading h2 {
  font-size: 22px;
  line-height: 1.4;
}
.dpo .results-heading p {
  margin-top: 6px;
  color: var(--dpo-muted);
  font-size: 13px;
}
.dpo .result-total {
  font-size: 13px;
  color: var(--dpo-muted);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.dpo .results-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--dpo-line);
}
.dpo .result-filters {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}
.dpo .result-filters > button {
  min-height: 36px;
  border: 0;
  border-radius: 6px;
  padding: 7px 14px;
  font-size: 13px;
  background: transparent;
  color: var(--dpo-muted);
}
.dpo .result-filters > button.active {
  background: var(--dpo-selected);
  color: var(--dpo-accent);
  font-weight: 650;
}
.dpo .result-filters > button:hover:not(:disabled) {
  background: var(--dpo-hover);
}
.dpo .result-search {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 1 300px;
  min-width: 0;
  padding: 0 6px 0 12px;
  background: var(--dpo-paper);
  border: 1px solid var(--dpo-control);
  border-radius: 8px;
}
.dpo .result-search > i {
  font-size: 13px;
  color: var(--dpo-muted);
}
.dpo .result-search > input {
  border: 0;
  background: transparent;
  padding: 8px 0;
  font-size: 13px;
}
.dpo .result-search .icon-button {
  flex-shrink: 0;
  color: var(--dpo-accent);
}
.dpo .results-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 48px;
  font-size: 12px;
  color: var(--dpo-muted);
}
.dpo .results-list {
  border-top: 1px solid var(--dpo-line);
}
.dpo .result-item {
  border-bottom: 1px solid var(--dpo-line);
  transition: background-color 0.18s ease;
}
.dpo .result-row {
  scroll-margin-top: calc(var(--workspace-header-height, 0px) + 12px);
  display: grid;
  grid-template-columns: 76px minmax(0, 1fr) 120px 20px;
  align-items: center;
  gap: 16px;
  width: 100%;
  min-height: 92px;
  padding: 16px 12px;
  border: 0;
  background: transparent;
  color: var(--dpo-text);
  text-align: left;
}
.dpo .result-row:hover:not(:disabled) {
  background: var(--dpo-hover);
}
.dpo .result-row:disabled {
  opacity: 0.75;
}
.dpo .result-question {
  min-width: 0;
}
.dpo .result-question > strong {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
  font-size: 15px;
  line-height: 1.65;
  font-weight: 600;
  color: var(--dpo-ink);
}
.dpo .result-question > span {
  display: block;
  margin-top: 5px;
  font-size: 12px;
  color: var(--dpo-muted);
  overflow-wrap: anywhere;
}
.dpo .result-date {
  color: var(--dpo-muted);
  font-size: 12px;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.dpo .result-chevron {
  justify-self: end;
  color: var(--dpo-muted);
  font-size: 12px;
  transition: transform 0.18s ease;
}
.dpo .result-item.expanded {
  background: var(--dpo-paper);
}
.dpo .result-item.expanded > .result-row {
  padding-block: 20px;
}
.dpo .result-item.expanded > .result-row .result-question > strong {
  -webkit-line-clamp: unset;
  font-size: 18px;
  line-height: 1.65;
}
.dpo .result-item.expanded .result-chevron {
  transform: rotate(180deg);
}
.dpo .result-detail {
  padding: 0 20px 20px;
  animation: dpo-reveal 0.18s ease-out;
}
.dpo .inline-comparison .question {
  padding: 0 0 16px;
}
.dpo .inline-comparison .evidence-access {
  margin-top: 0;
}
.dpo .inline-comparison .response-body {
  min-height: 0;
}
.dpo .inline-save {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0 12px;
  font-size: 12px;
  color: var(--dpo-success);
}
.dpo .filter-changed-note {
  font-size: 12px;
  padding: 10px 12px;
  margin-bottom: 12px;
  background: var(--dpo-warning-soft);
  color: var(--dpo-warning);
  border-radius: 7px;
}
.dpo .badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  width: fit-content;
  min-width: 54px;
  padding: 4px 8px;
  border-radius: 6px;
  background: var(--dpo-soft);
  color: var(--dpo-ink);
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.dpo .badge.preferred {
  background: var(--dpo-selected);
  color: var(--dpo-accent);
}
.dpo .badge.hold {
  background: var(--dpo-warning-soft);
  color: var(--dpo-warning);
}
.dpo .empty-results {
  padding: 52px 16px;
  text-align: center;
  color: var(--dpo-muted);
}
.dpo .empty-results > i {
  font-size: 26px;
  color: var(--dpo-muted);
  margin-bottom: 12px;
}
.dpo .empty-results h3 {
  margin-bottom: 8px;
}
.dpo .empty-results p {
  font-size: 13px;
}
.dpo .pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 18px 0;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}
.dpo .pagination button {
  border: 1px solid var(--dpo-line);
}
.dpo .feedback {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  margin-bottom: 16px;
  border-radius: 8px;
  font-size: 13px;
  overflow-wrap: anywhere;
}
.dpo .feedback.error {
  background: var(--dpo-danger-soft);
  color: var(--dpo-danger);
  border: 1px solid color-mix(in srgb, var(--dpo-danger) 55%, var(--dpo-paper));
}
.dpo .feedback.success {
  background: var(--dpo-success-soft);
  color: var(--dpo-success);
  border: 1px solid color-mix(in srgb, var(--dpo-success) 55%, var(--dpo-paper));
}
.dpo .feedback .button, .dpo .feedback a {
  margin-left: auto;
  flex-shrink: 0;
}
.dpo .feedback button:not(.button) {
  border: 0;
  background: none;
  color: inherit;
  text-decoration: underline;
}
.dpo .evaluation-feedback {
  margin: 12px 0;
  align-items: center;
  flex-wrap: wrap;
}
.dpo .evaluation-feedback strong {
  display: block;
  margin-bottom: 3px;
}
.dpo .evaluation-feedback > div {
  flex: 1 1 200px;
}
.dpo .demo-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  margin-bottom: 18px;
  background: var(--dpo-warning-soft);
  color: var(--dpo-warning);
  border-radius: 8px;
  font-size: 13px;
}
.dpo .demo-banner span {
  display: block;
  font-size: 12px;
  margin-top: 3px;
}
.dpo .loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 180px;
  color: var(--dpo-muted);
}
.dpo .spinner {
  display: inline-block;
  flex: 0 0 auto;
  width: 15px;
  height: 15px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: dpo-spin 0.8s linear infinite;
}
.dpo .rotating {
  animation: dpo-spin 0.8s linear infinite;
}
.dpo .busy-indicator {
  position: fixed;
  bottom: 16px;
  right: 20px;
  z-index: 80;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: var(--dpo-dark);
  color: var(--dpo-on-dark);
  border-radius: 9px;
  font-size: 12px;
}
.dpo .editor {
  max-width: 1280px;
  margin: 0 auto;
  padding: 24px;
  border: 1px solid var(--dpo-line);
  border-radius: 14px;
  background: var(--dpo-paper);
}
.dpo .section-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding-bottom: 20px;
  margin-bottom: 12px;
  border-bottom: 1px solid var(--dpo-line);
}
.dpo .section-heading h2 {
  font-size: 23px;
}
.dpo .section-heading p {
  font-size: 13px;
  margin-top: 6px;
  color: var(--dpo-muted);
}
.dpo .section-heading .button {
  flex-shrink: 0;
}
.dpo .caution {
  padding: 12px 14px;
  background: var(--dpo-warning-soft);
  color: var(--dpo-warning);
  border-radius: 8px;
  font-size: 13px;
  margin-bottom: 16px;
}
.dpo .qa-origin-note {
  padding: 14px 16px;
  background: var(--dpo-soft);
  border-radius: 10px;
  margin: 16px 0;
  font-size: 13px;
}
.dpo .qa-origin-note > strong {
  margin-right: 12px;
}
.dpo .qa-origin-source {
  overflow-wrap: anywhere;
}
.dpo .qa-origin-note > p {
  margin-top: 6px;
  color: var(--dpo-muted);
}
.dpo .qa-origin-details {
  margin-top: 6px;
}
.dpo .qa-origin-details dd {
  overflow-wrap: anywhere;
}
.dpo .comparison-preparation {
  display: flex;
  align-items: center;
  gap: 12px 20px;
  flex-wrap: wrap;
  margin: 18px 0;
  padding: 18px;
  background: var(--dpo-soft);
  border-radius: 10px;
  font-size: 13px;
}
.dpo .comparison-preparation > div {
  flex: 1 1 320px;
}
.dpo .comparison-preparation p {
  margin-top: 5px;
  color: var(--dpo-muted);
}
.dpo .comparison-preparation > details {
  width: 100%;
}
.dpo .guide-summary ul {
  padding-left: 20px;
  line-height: 1.8;
}
.dpo .guide-summary dl > div {
  margin-bottom: 8px;
}
.dpo .guide-summary dd {
  margin: 4px 0;
  color: var(--dpo-muted);
}
.dpo .guide-version {
  font-size: 12px;
  font-weight: 400;
}
.dpo .response-editor {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}
.dpo .response-editor textarea {
  font-size: 16px;
  line-height: 1.8;
}
.dpo .model-fields {
  margin-top: 20px;
  border-block: 1px solid var(--dpo-line);
  padding: 8px 0;
  font-size: 13px;
}
.dpo .model-fields > summary {
  padding: 8px 0;
}
.dpo .b-preflight {
  padding: 18px;
  background: var(--dpo-soft);
  border-radius: 10px;
  margin-top: 20px;
  font-size: 13px;
}
.dpo .b-preflight h3 {
  font-size: 18px;
  margin-bottom: 8px;
}
.dpo .b-signals {
  padding-left: 20px;
  margin: 12px 0;
}
.dpo .b-signals li {
  margin-bottom: 10px;
}
.dpo .b-signals q {
  display: block;
  margin-top: 4px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  color: var(--dpo-muted);
}
.dpo .b-blocker {
  color: var(--dpo-danger);
  margin-top: 8px;
}
.dpo .b-check {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-weight: 500;
  line-height: 1.7;
}
.dpo .b-check > input {
  width: 18px;
  height: 18px;
  min-height: 18px;
  margin-top: 3px;
  accent-color: var(--dpo-accent);
}
.dpo .b-check-help {
  font-size: 12px;
  margin-top: 12px;
  color: var(--dpo-muted);
}
.dpo .form-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  padding-top: 24px;
  margin-top: 20px;
  border-top: 1px solid var(--dpo-line);
  font-size: 13px;
  color: var(--dpo-muted);
}
.dpo .qa-search {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 160px auto;
  gap: 12px;
  margin-top: 20px;
}
.dpo .qa-list-meta, .dpo .qa-top-pagination {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dpo .qa-list-meta {
  padding: 16px 0;
  color: var(--dpo-muted);
  font-size: 13px;
}
.dpo .qa-list-meta > .text-button {
  margin-left: auto;
}
.dpo .qa-results {
  border-top: 1px solid var(--dpo-line);
}
.dpo .qa-row {
  display: grid;
  grid-template-columns: 72px minmax(0, 1.2fr) minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  padding: 18px 0;
  border-bottom: 1px solid var(--dpo-line);
  font-size: 13px;
}
.dpo .qa-row > strong {
  font-size: 14px;
  overflow-wrap: anywhere;
}
.dpo .qa-source {
  color: var(--dpo-muted);
  overflow-wrap: anywhere;
}
.dpo .qa-registration {
  display: block;
  margin-top: 5px;
}
.dpo .qa-use {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 6px;
}
.dpo .list-empty {
  padding: 32px 16px;
  text-align: center;
  color: var(--dpo-muted);
}

@media (hover: hover) and (pointer: fine) {
  .dpo .response.selectable:hover {
    background: var(--dpo-selected);
  }
  .dpo .response.selectable:hover > header {
    background: var(--dpo-accent);
    border-bottom-color: var(--dpo-accent);
  }
  .dpo .response.selectable:hover :is(.card-choice, .response-select-hint) {
    color: var(--dpo-on-dark);
  }
  .dpo .response.selectable:hover .response-select-hint > i {
    transform: translateX(3px);
  }
}
@media (max-width: 1200px) {
  .dpo .session-panel, .dpo .home-details {
    gap: 28px;
  }
  .dpo .session-panel {
    padding: 30px;
  }
  .dpo .session-progress {
    padding-left: 24px;
  }
  .dpo .reader-layout.evidence-open {
    grid-template-columns: minmax(0, 1fr);
  }
  .dpo .reader-layout.evidence-open > .reference-pane {
    grid-column: 1;
    grid-row: 1;
    position: relative;
    top: 0;
    max-height: 50dvh;
  }
  .dpo .reader-layout.evidence-open > .review-primary {
    grid-column: 1;
    grid-row: 2;
  }
  .dpo .result-row {
    grid-template-columns: 72px minmax(0, 1fr) 100px 16px;
    gap: 12px;
  }
}
@media (max-width: 960px) {
  .dpo {
    min-height: calc(100dvh - var(--workspace-header-height, 104px));
    padding: 20px 18px 32px;
  }
  .dpo .dpo-header {
    gap: 16px;
    margin-bottom: 20px;
  }
  .dpo .session-panel {
    grid-template-columns: minmax(0, 1fr);
    gap: 30px;
  }
  .dpo .session-intro h2 {
    max-width: none;
    font-size: 28px;
  }
  .dpo .session-progress {
    padding: 20px 0 0;
    border-left: 0;
    border-top: 1px solid var(--dpo-dark-line);
  }
  .dpo .progress-heading {
    margin-bottom: 14px;
  }
  .dpo .home-details {
    grid-template-columns: minmax(0, 1fr);
    gap: 26px;
    padding: 26px 0 0;
  }
  .dpo .next-preview {
    padding: 0;
  }
  .dpo .home-guide {
    border-top: 1px solid var(--dpo-line);
    padding-top: 20px;
  }
  .dpo .home-guide ol {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 24px;
  }
  .dpo .home-guide li {
    flex: 1 1 190px;
  }
  .dpo .results-toolbar {
    align-items: stretch;
    flex-wrap: wrap;
    gap: 12px;
  }
  .dpo .result-search {
    flex: 1 1 260px;
  }
  .dpo .result-filters {
    flex: 1 1 320px;
  }
  .dpo .qa-row {
    grid-template-columns: 64px minmax(0, 1fr) auto;
  }
  .dpo .qa-source {
    grid-column: 2;
    grid-row: 2;
  }
  .dpo .qa-use {
    grid-column: 3;
    grid-row: 1/3;
  }
  .dpo .reference-pane {
    max-height: 55dvh;
  }
}
@media (max-width: 600px) {
  .dpo {
    padding: 16px 12px 28px;
  }
  .dpo .dpo-header {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 10px 12px;
    margin-bottom: 20px;
  }
  .dpo .dpo-header > h1 {
    font-size: 22px !important;
  }
  .dpo .mode-switch > button {
    min-height: 40px;
    padding: 8px 12px;
    font-size: 13px;
  }
  .dpo .header-progress {
    grid-column: 1/-1;
    margin: 0;
    justify-content: space-between;
    font-size: 12px;
  }
  .dpo .header-progress progress {
    width: 120px;
  }
  .dpo.evaluating .dpo-header {
    margin-bottom: 18px;
  }
  .dpo .session-panel {
    padding: 24px 20px;
    border-radius: 12px;
    gap: 24px;
  }
  .dpo .session-intro h2 {
    font-size: 24px;
    line-height: 1.5;
  }
  .dpo .session-intro > p {
    font-size: 13px;
    margin-top: 12px;
  }
  .dpo .session-action {
    margin-top: 22px;
    gap: 10px;
  }
  .dpo .session-action > span {
    width: 100%;
  }
  .dpo .session-action .button {
    min-height: 46px;
    padding: 12px 18px;
  }
  .dpo .progress-heading {
    margin-bottom: 12px;
  }
  .dpo .progress-heading > strong {
    font-size: 26px;
  }
  .dpo .session-counts {
    gap: 10px;
    margin-top: 16px;
  }
  .dpo .session-counts dd {
    font-size: 18px;
  }
  .dpo .session-counts dd > span {
    display: block;
    margin-top: 2px;
    font-size: 11px;
  }
  .dpo .next-preview > p {
    font-size: 18px;
    line-height: 1.7;
    margin-top: 12px;
  }
  .dpo .home-guide ol {
    display: block;
  }
  .dpo .home-guide li {
    padding: 7px 0;
  }
  .dpo .question {
    padding: 0 0 16px;
  }
  .dpo .question h2 {
    font-size: 20px;
    line-height: 1.65;
  }
  .dpo .evidence-access {
    gap: 8px 12px;
    margin-top: 10px;
  }
  .dpo .question-source {
    flex-basis: 100%;
    font-size: 12px;
  }
  .dpo #evidence-toggle {
    min-height: 40px;
  }
  .dpo .responses {
    grid-template-columns: minmax(0, 1fr);
    gap: 1px;
    border-radius: 10px;
  }
  .dpo .response-body, .dpo .inline-comparison .response-body {
    max-height: none;
    min-height: 0;
    overflow: visible;
    padding: 18px 16px;
    font-size: 16px;
    line-height: 1.85;
  }
  .dpo .card-choice {
    padding: 12px 16px;
    min-height: 52px;
  }
  .dpo .response > header {
    min-height: 52px;
  }
  .dpo .response-select-hint {
    font-size: 12px;
  }
  .dpo .decision-bar {
    position: sticky;
    bottom: 0;
    z-index: 5;
    margin-top: 14px;
    padding: 10px 10px max(10px, env(safe-area-inset-bottom));
    background: var(--dpo-soft);
    border-top: 1px solid var(--dpo-line);
    border-radius: 10px 10px 0 0;
  }
  .dpo .decision-intro {
    font-size: 11px;
    margin-bottom: 6px;
  }
  .dpo .evaluation-toolbar {
    gap: 8px;
  }
  .dpo .decision-actions {
    gap: 6px;
  }
  .dpo .decision-actions .button {
    min-height: 44px;
    padding: 10px 12px;
    font-size: 13px;
    gap: 6px;
  }
  .dpo #memo-toggle {
    min-height: 44px;
    font-size: 12px;
    padding-inline: 0;
    gap: 5px;
  }
  .dpo .reason-section {
    display: block;
    padding-top: 14px;
  }
  .dpo .reason-section > label {
    margin-top: 12px;
  }
  .dpo .reason-section > textarea {
    font-size: 16px;
  }
  .dpo .memo-save {
    margin-top: 12px;
    min-height: 44px;
  }
  .dpo .hold-reasons {
    padding: 8px 0;
  }
  .dpo .hold-reason-actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
  }
  .dpo .hold-reason-actions .button {
    justify-content: flex-start;
    min-height: 44px;
  }
  .dpo .hold-other-actions {
    gap: 12px;
  }
  .dpo .evidence-panel {
    padding: 0 14px 14px;
  }
  .dpo .evidence-heading {
    margin: 0 -14px 10px;
  }
  .dpo .evidence-heading .text-button {
    min-height: 40px;
  }
  .dpo .evidence-panel summary {
    min-height: 40px;
    padding-block: 8px;
  }
  .dpo .reader-layout {
    gap: 14px;
  }
  .dpo .results-heading {
    align-items: flex-start;
    margin-bottom: 18px;
  }
  .dpo .results-heading h2 {
    font-size: 20px;
  }
  .dpo .results-heading p {
    font-size: 12px;
    max-width: 30ch;
  }
  .dpo .result-total {
    font-size: 12px;
  }
  .dpo .results-toolbar {
    display: block;
    padding-bottom: 12px;
  }
  .dpo .result-filters {
    display: flex;
    gap: 2px;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-bottom: 12px;
  }
  .dpo .result-filters > button {
    min-height: 40px;
    padding: 8px 10px;
    font-size: 12px;
  }
  .dpo .result-search > input {
    font-size: 16px;
    min-height: 42px;
  }
  .dpo .results-meta {
    min-height: 46px;
  }
  .dpo .result-row {
    grid-template-columns: 58px minmax(0, 1fr) 14px;
    align-items: start;
    gap: 8px;
    padding: 16px 6px;
  }
  .dpo .result-question > strong {
    font-size: 14px;
    line-height: 1.7;
  }
  .dpo .result-question > span {
    font-size: 11px;
  }
  .dpo .result-date {
    grid-column: 2;
    grid-row: 2;
    text-align: left;
    font-size: 11px;
  }
  .dpo .result-chevron {
    grid-column: 3;
    grid-row: 1;
    margin-top: 8px;
  }
  .dpo .result-item.expanded > .result-row {
    padding-block: 18px 12px;
  }
  .dpo .result-item.expanded > .result-row .result-question > strong {
    font-size: 16px;
  }
  .dpo .result-detail {
    padding: 0 10px 12px;
  }
  .dpo .inline-comparison .question {
    padding-bottom: 12px;
  }
  .dpo .item-record-body {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }
  .dpo .record-count {
    font-size: 11px;
  }
  .dpo .item-tools > summary {
    gap: 6px;
    font-size: 12px;
  }
  .dpo .pagination .icon-button {
    min-width: 44px;
    min-height: 44px;
  }
  .dpo .editor {
    padding: 18px 14px;
    border-radius: 10px;
  }
  .dpo .section-heading {
    flex-direction: column;
    gap: 12px;
  }
  .dpo .section-heading h2 {
    font-size: 21px;
  }
  .dpo .section-heading .button {
    align-self: flex-start;
    min-height: 44px;
  }
  .dpo .response-editor {
    grid-template-columns: minmax(0, 1fr);
    gap: 8px;
  }
  .dpo .editor :is(input, textarea, select) {
    font-size: 16px;
    min-height: 44px;
  }
  .dpo .editor .b-check > input {
    min-height: 18px;
  }
  .dpo .comparison-preparation {
    padding: 14px;
  }
  .dpo .comparison-preparation .button {
    min-height: 44px;
  }
  .dpo .form-footer {
    gap: 12px;
  }
  .dpo .form-footer .button {
    width: 100%;
    min-height: 46px;
  }
  .dpo .qa-search {
    grid-template-columns: minmax(0, 1fr) 120px;
  }
  .dpo .qa-search > .button {
    grid-column: 1/-1;
    min-height: 44px;
  }
  .dpo .qa-list-meta {
    flex-wrap: wrap;
    gap: 6px 12px;
  }
  .dpo .qa-row {
    grid-template-columns: 58px minmax(0, 1fr);
    padding: 14px 0;
  }
  .dpo .qa-use {
    grid-column: 2;
    grid-row: auto;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 4px 12px;
  }
  .dpo .qa-use .text-button {
    min-height: 44px;
  }
  .dpo .qa-source {
    grid-row: auto;
  }
  .dpo .busy-indicator {
    bottom: 10px;
    right: 12px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .dpo *, .dpo *::before, .dpo *::after {
    animation: none !important;
    transition: none !important;
    scroll-behavior: auto !important;
  }
}
@keyframes dpo-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes dpo-reveal {
  from {
    opacity: 0.92;
  }
  to {
    opacity: 1;
  }
}
.dpo .home-details {
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
}

.dpo .home-guide {
  border-top: 1px solid var(--dpo-line);
  margin-top: 8px;
}

.dpo .home-guide > summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 48px;
  list-style: none;
  font-weight: 600;
  color: var(--dpo-muted);
}

.dpo .home-guide > summary::-webkit-details-marker {
  display: none;
}

.dpo .home-guide > summary > i {
  font-size: 11px;
}

.dpo .home-guide[open] > summary > i {
  transform: rotate(180deg);
}

.dpo .home-guide > p {
  font-size: 13px;
  max-width: 75ch;
  margin: 8px 0;
  color: var(--dpo-muted);
}

.dpo .home-guide ol {
  max-width: 75ch;
}

.dpo .results-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid var(--dpo-line);
  margin-bottom: 0;
  padding-bottom: 10px;
}

.dpo .results-controls .results-toolbar {
  flex: 1;
  min-width: 0;
  margin: 0;
}

.dpo .results-controls .results-meta {
  gap: 10px;
  flex: none;
  min-height: 40px;
}

@media (max-width: 1200px) {
  .dpo .results-controls {
    flex-wrap: wrap;
  }
  .dpo .results-controls .results-toolbar {
    flex-basis: 100%;
  }
  .dpo .results-controls .results-meta {
    width: 100%;
    min-height: 30px;
  }
}`],
})
export class PageDpoComponent implements OnInit, OnDestroy {
    openRow(event:MouseEvent) { activateListRow(event); }
    workspacePage=true; user:any=null; guide:any=null; csrf=''; ready=false; busy=false; error=''; notice=''; forbidden=false;
    permissions:any={can_write:false,can_export:false,can_manage:false}; stats:any={total:0,pending:0,preferred:0,tie:0,hold:0,exportable:0};
    reviewStarted=false; adminPreparation=false;
    tab='review'; rows:any={items:[],total:0,page:1,pages:1,exportable_count:null}; query=''; status='PENDING'; appliedQuery=''; appliedStatus='PENDING'; selected:any=null;
    demo=false; reveal=false; choice=''; reasonTag=''; reason=''; baseline=''; editor:any=null; editorBaseline=''; queueOpen=false; evidenceOpen=false; evidenceBlocks:any[]=[]; started=false;
    memoOpen=false; managementOpen=false; recheckMode=false; holdOpen=false; private holdPreviousChoice='';
    evaluationPhase=''; evaluationError=false; nextLoadFailed=false; contextRefreshFailed=false;
    private listContexts:any={}; private resultPosition=0;
    private cardGesture:any=null;
    private evidenceScroll=0;
    private evidenceItem='';
    reviewScope='all'; appliedReviewScope='all'; private reviewTabScope='all';
    reviewScopes=[{id:'all',label:'전체 자료'},{id:'ready',label:'원문 확인 필요 제외'},{id:'source_review',label:'원문 확인 필요'},{id:'supplemented',label:'교정·보충 근거'}];
    lastEvaluation:any=null; private sessionEvaluated=new Set<string>();
    bInspection:any=null; bInspectionSnapshot=''; bQuestionChecked=false; bEvidenceChecked=false; bExceptionNote='';
    private preparationTab='review';
    qaPicker=false; qaQuery=''; qaGroup=''; appliedQaQuery=''; appliedQaGroup=''; qaRows:any={items:[],total:0,page:1,pages:1};
    qaGroups=[{id:'',label:'전체 자료'},{id:'TEXTBOOK',label:'교과서'},{id:'GUIDELINE',label:'지침'},{id:'PAPER',label:'논문'}];
    private dead=false; private loggedOut=false; private controllers=new Set<AbortController>(); private routeConfig:any; private previousGuards:any;
    states=[{id:'PENDING',label:'평가 대기'},{id:'',label:'전체 상태'},{id:'A',label:'A 선호'},{id:'B',label:'B 선호'},{id:'TIE',label:'동률'},{id:'HOLD',label:'보류'}];
    private reasonGroups:any={
        A:['문헌 근거에 충실함','질문에 더 적합함','조건·한계를 더 잘 보존함','과도한 단정이 적음'],
        B:['문헌 근거에 충실함','질문에 더 적합함','조건·한계를 더 잘 보존함','과도한 단정이 적음'],
        TIE:['두 응답이 비슷함'],
        HOLD:['근거 확인이 필요함','두 응답 모두 부적절함','차이를 판단하기 어려움']
    };
    constructor(@Inject(Service) public service:Service,@Inject(ActivatedRoute)  private route:ActivatedRoute,@Inject(Router)  private router:Router) {
        const session=this.route.snapshot?.data?.['workspace']?.session;
        if(session?.code===200 && session.data?.user) {this.user=session.data.user;this.csrf=session.data.csrf;}
    }
    async ngOnInit() {
        this.routeConfig=this.route.snapshot.routeConfig;
        if(this.routeConfig){this.previousGuards=this.routeConfig.canDeactivate;this.routeConfig.canDeactivate=[...(this.previousGuards||[]),()=>this.leave()];}
        await this.service.init(); await this.initialize();
    }
    ngOnDestroy() {this.dead=true;this.controllers.forEach(c=>c.abort());if(this.routeConfig)this.routeConfig.canDeactivate=this.previousGuards;}
    @HostListener('window:beforeunload',['$event'])
    beforeUnload(e:BeforeUnloadEvent) {if(!this.loggedOut&&this.dirty){e.preventDefault();e.returnValue='';}}
    get dirty() {return this.editor ? JSON.stringify(this.editor)!==this.editorBaseline : !!this.selected && JSON.stringify([this.choice,this.reasonTag,this.reason])!==this.baseline;}
    get browsing() {return this.tab==='dataset';}
    get evaluating() {return this.tab==='review'&&this.reviewStarted&&!!this.selected&&!this.editor&&!this.qaPicker;}
    get progress() {return this.stats.total?Math.min(100,Math.round(this.recordedCount/this.stats.total*100)):0;}
    get resultItems() {
        if(!this.selected)return this.rows.items;
        const items=this.rows.items.filter((row:any)=>row.id!==this.selected.id);
        items.splice(Math.min(this.resultPosition,items.length),0,this.selected);
        return items;
    }
    trackResult(index:number,row:any) {return row.id;}
    get resultOutsideFilter() {return !!this.selected&&!this.rows.items.some((row:any)=>row.id===this.selected.id);}
    get sessionCount() {return this.sessionEvaluated.size;}
    get scopeLabel() {return this.reviewScopes.find(s=>s.id===this.appliedReviewScope)?.label || '전체 자료';}
    get scopePendingCount() {
        if(this.appliedStatus==='PENDING')return this.rows.total || 0;
        return this.stats.review_pending?.[this.reviewTabScope] ?? this.stats.pending ?? 0;
    }
    scopeCount(scope:string) {return this.rows.scope_counts?.[scope] ?? this.stats.review_pending?.[scope] ?? 0;}
    async toggleManagement() {
        if(this.busy||this.dead)return;
        this.managementOpen=!this.managementOpen;
        await this.render();
        if(!this.managementOpen)document.getElementById('management-toggle')?.focus({preventScroll:true});
    }
    get reasonOptions():string[] {return this.reasonGroups[this.choice] || [];}
    get effectiveReason() {return [this.reasonTag,this.reason.trim()].filter(Boolean).join('\n');}
    get canSave() {return !!this.choice && (this.choice!=='HOLD'||!!this.effectiveReason) && this.effectiveReason.length<=2000 && this.dirty;}
    get selectedLabel() {return this.recheckMode ? '독립 재검토 중' : this.label(this.selected?.decision);}
    get preferred() {return !this.recheckMode && ['A','B'].includes(this.selected?.decision);}
    get recordedCount() {return this.stats.preferred+this.stats.tie+this.stats.hold;}
    get filterStates() {return this.tab==='dataset' ? [{id:'EVALUATED',label:'내 전체 평가'},...this.states.filter(s=>['A','B','TIE','HOLD'].includes(s.id))] : this.states;}
    get canEvaluate() {return !!this.selected&&!this.qaPicker&&!this.editor&&(this.demo||this.permissions.can_write)&&(this.tab==='dataset'||(this.reviewStarted&&this.selected.decision==='PENDING')||this.demo);}
    decisionReason(id:string) {return ({A:'응답 A 선호',B:'응답 B 선호',TIE:'동률로 판단',HOLD:'판단 보류'} as any)[id] || '';}
    label(v:string) {return this.states.find(x=>x.id===v)?.label || '평가 대기';}
    date(v:string) {return formatWorkspaceDate(v);}
    actionLabel(v:string) {return ({CREATE:'등록',EDIT:'내용 수정',EVALUATE:'선호 평가',RESET:'평가 해제',ARCHIVE:'보관'} as any)[v] || '변경';}
    uuid() {return Array.from(crypto.getRandomValues(new Uint8Array(16))).map(x=>x.toString(16).padStart(2,'0')).join('');}
    async render() {if(!this.dead)await this.service.render();}
    async focus(id:string) {
        await this.render();if(id==='question-heading')this.resetAnswerScroll(true);
        const element=document.getElementById(id);
        const scrollTarget=id==='question-heading'?(document.getElementById('dpo-heading')||element):element;
        scrollTarget?.scrollIntoView({block:id==='question-heading'?'start':'nearest',behavior:'instant'});element?.focus({preventScroll:true});
    }
    @HostListener('window:resize')
    resetAnswerScroll(force=false) {
        if(!force && window.innerWidth>600)return;
        if(!document.querySelectorAll)return;
        document.querySelectorAll<HTMLElement>(force?'.comparison .response-body, #dpo-evidence':'.comparison .response-body').forEach(panel=>panel.scrollTo({top:0,behavior:'instant'}));
    }
    async goToReading(target:string) {
        if(this.busy || this.dead || !this.selected)return;
        const ids:any={question:'question-heading',A:'answer-a-heading',B:'answer-b-heading',decision:'decision-heading'};
        if(!ids[target] || (target==='decision'&&!this.canEvaluate))return;
        await this.render();
        const element=document.getElementById(ids[target]);
        element?.scrollIntoView({block:'start',behavior:'instant'});element?.focus({preventScroll:true});
    }
    async retryNext() {
        if(this.busy || this.dead || !this.nextLoadFailed || !this.selected || this.dirty)return;
        this.evaluationPhase='next';
        await this.startReview();
        this.evaluationPhase='';
        if(this.error){this.evaluationError=true;await this.focus('evaluation-feedback');}
        else await this.render();
    }
    async call(action:string,values:any={}) {
        const controller=new AbortController();this.controllers.add(controller);const timer=setTimeout(()=>controller.abort(),action==='export_bundle'?180000:30000);
        try {
            const body=new URLSearchParams();
            for(const [k,v] of Object.entries({action,csrf:this.csrf,...values})) body.append(k,String(v));
            const response=await fetch('/wiz/api/page.dpo/dispatch',{method:'POST',body,credentials:'same-origin',signal:controller.signal});
            const r=await response.json();
            if(this.dead)throw new Error('화면을 닫아 요청을 취소했습니다.');
            if(r.code!==200) {
                const code=r.code || response.status;
                if(code===401) {this.forbidden=true;throw new Error('로그인이 만료되었습니다. 작성 내용을 보관한 뒤 다시 로그인해 주세요.');}
                if(code===403) {if(!this.ready)this.forbidden=true;throw new Error(r.data?.message || '이 작업을 수행할 권한이 없습니다. 계정 권한을 확인해 주세요.');}
                if(code===409) throw new Error('다른 작업에서 이 기록이 변경되었습니다. 입력 내용을 보관한 뒤 최신 기록을 다시 열어 주세요.');
                throw new Error(r.data?.message || '요청을 처리하지 못했습니다. 입력 내용을 확인하고 다시 시도해 주세요.');
            }
            return r.data;
        } catch(e:any) {
            if(e?.name==='AbortError')throw new Error(action==='export_bundle'?'결과 자료 준비가 지연되고 있습니다. 잠시 후 다시 시도해 주세요.':'응답이 지연되고 있습니다. 입력은 유지됩니다. 다시 저장하기 전에 목록에서 저장 여부를 확인해 주세요.');
            if(e instanceof TypeError || e instanceof SyntaxError)throw new Error('서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.');
            throw new Error(e?.message || '요청을 처리하지 못했습니다. 연결을 확인하고 다시 시도해 주세요.');
        } finally {clearTimeout(timer);this.controllers.delete(controller);}
    }
    async task(fn:()=>Promise<void>) {
        if(this.busy || this.dead)return;this.busy=true;this.error='';this.notice='';this.evaluationError=false;await this.render();
        try {if(!this.dead)await fn();}catch(e:any){if(!this.dead){this.error=e?.message || '요청을 처리하지 못했습니다. 다시 시도해 주세요.';this.evaluationError=!!this.evaluationPhase;}}finally{this.busy=false;await this.render();}
    }
    async bootstrap() {const d=await this.call('bootstrap');this.user=d.user;this.csrf=d.csrf;this.permissions=d.permissions;this.stats=d.stats;this.guide=d.guide || null;}
    async list(page=1,q=this.appliedQuery,status=this.appliedStatus,scope=this.appliedReviewScope) {
        const rows=await this.call('list',{q,status,page,review_scope:scope});
        this.setListing(rows,q,status,scope);
    }
    setListing(rows:any,q:string,status:string,scope=this.appliedReviewScope) {
        this.rows=rows;this.appliedQuery=q;this.appliedStatus=status;this.appliedReviewScope=scope;
        this.listContexts[this.tab]={q,status,scope,page:rows.page};
        if(this.tab==='review')this.reviewTabScope=scope;
        this.restoreFilters();
    }
    restoreFilters() {this.query=this.appliedQuery;this.status=this.appliedStatus;this.reviewScope=this.appliedReviewScope;}
    clearSelection() {this.selected=null;this.demo=false;this.recheckMode=false;this.choice='';this.reason='';this.reasonTag='';this.baseline='';this.evidenceBlocks=[];this.memoOpen=false;this.holdOpen=false;this.nextLoadFailed=false;this.contextRefreshFailed=false;this.evaluationError=false;}
    async initialize() {
        const editId=this.route.snapshot?.queryParamMap?.get('edit')||'';
        const prepare=this.route.snapshot?.queryParamMap?.get('prepare')||'';
        this.adminPreparation=!!editId||!!prepare;
        const openResults=!this.adminPreparation && this.route.snapshot?.queryParamMap?.get('view')==='results';
        const resume=!this.adminPreparation && !openResults && this.route.snapshot?.queryParamMap?.get('start')==='1';
        await this.task(async()=>{
            await this.bootstrap();
            if(!openResults && (!resume || !this.permissions.can_write))await this.list(1,'','PENDING','all');
            try {
                if(this.adminPreparation&&!this.permissions.can_manage)throw new Error('평가 자료 관리는 관리자만 가능합니다.');
                if(prepare&&!['qa','manual'].includes(prepare))throw new Error('자료 등록 경로를 확인해 주세요.');
                if(editId) {this.accept(await this.call('detail',{id:editId}));this.preparePairEditor();}
            } finally {this.ready=true;}
        });
        if(this.error)return;
        if(editId&&this.editor)await this.focus('pair-title');
        else if(prepare==='qa')await this.startQA();
        else if(prepare==='manual')await this.newPair();
        else if(openResults)await this.changeTab('dataset');
        else if(resume)await this.startReview();
    }
    leave() {return this.loggedOut || (!this.busy && (!this.dirty || window.confirm('저장하지 않은 내용이 있습니다. 변경사항을 버리고 이동하시겠습니까?')));}
    afterLogout() {this.loggedOut=true;}
    async navigateWorkspace(value:string) {
        if(this.busy||this.dead||this.editor||this.qaPicker||!['review','dataset'].includes(value))return;
        if(value===this.tab&&(value==='dataset'||!this.reviewStarted))return;
        if(!this.leave())return;
        const context=value==='dataset'?(this.listContexts.dataset||{q:'',status:'EVALUATED',scope:'all',page:1}):{q:'',status:'PENDING',scope:'all',page:1};
        await this.task(async()=>{
            const rows=await this.call('list',{q:context.q,status:context.status,page:context.page,review_scope:context.scope});
            this.tab=value;this.reviewStarted=false;this.clearSelection();this.evidenceOpen=false;
            this.setListing(rows,context.q,context.status,context.scope);this.queueOpen=false;
        });
        if(!this.error)await this.focus('dpo-heading');
    }
    async changeTab(value:string,stayInList=false) {await this.navigateWorkspace(value);}
    async startReview() {
        if(!this.permissions.can_write||!this.leave())return;
        await this.task(async()=>{
            const rows=await this.call('list',{q:'',status:'PENDING',page:1,review_scope:'all'});
            const next=rows.items.length?await this.call('detail',{id:rows.items[0].id}):null;
            this.tab='review';this.editor=null;this.qaPicker=false;this.setListing(rows,'','PENDING','all');
            if(next) {this.accept(next);this.reviewStarted=true;}
            else {this.clearSelection();this.reviewStarted=false;await this.bootstrap();this.notice='평가할 문항이 없습니다.';}
        });
        if(!this.error&&this.selected)await this.focus('question-heading');
    }
    async setResultFilter(value:string) {
        if(this.busy||!this.filterStates.some(s=>s.id===value))return;
        this.status=value;await this.search();
    }
    async toggleQueue() {await this.navigateWorkspace('dataset');}
    async toggleEvidence() {
        if(this.busy||this.dead)return;
        const opening=!this.evidenceOpen;
        if(opening){this.evidenceScroll=window.scrollY||0;this.evidenceItem=this.selected?.id||'';}
        this.evidenceOpen=opening;await this.render();
        if(!opening&&window.innerWidth<=1200&&this.evidenceItem===this.selected?.id)window.scrollTo({top:this.evidenceScroll,behavior:'instant'});
        document.getElementById(opening?'evidence-heading':'evidence-toggle')?.focus({preventScroll:true});
    }
    @HostListener('document:keydown.escape',['$event'])
    async closeEvidenceKey(event:KeyboardEvent) {
        if(!this.evidenceOpen || this.busy || event.defaultPrevented ||
           (event.target as Element)?.closest?.('input,textarea,select,[contenteditable=true]'))return;
        event.preventDefault();await this.toggleEvidence();
    }
    async toggleMemo() {this.memoOpen=!this.memoOpen;await this.focus(this.memoOpen?'evaluation-reason':'memo-toggle');}
    parseEvidence(row:any):any[] {
        const text=row.evidence||'',refs=row.origin?.references;
        if(!Array.isArray(refs)||!refs.length)return [];
        const headers=refs.map((r:any)=>'['+r.title+' · PDF '+r.page+'쪽]\n인용: ');
        const separator='\n\n주변 원문:\n',blocks:any[]=[];let cursor=0;
        for(let i=0;i<headers.length;i++) {
            if(!text.startsWith(headers[i],cursor))return [];
            const start=cursor+headers[i].length;
            const end=i+1<headers.length?text.indexOf('\n\n'+headers[i+1],start):text.length;
            if(end<0)return [];
            const split=text.indexOf(separator,start);
            if(split<start||split>=end)return [];
            const extra=text.indexOf(separator,split+separator.length);
            if(extra>=0&&extra<end)return [];
            const quote=text.slice(start,split),context=text.slice(split+separator.length,end);
            if(!quote||!context.includes(quote))return [];
            blocks.push({source:refs[i].title+' · PDF '+refs[i].page+'쪽',quote,context});
            cursor=end+2;
        }
        return blocks;
    }
    async search(page=1,applyFilters=true) {
        const q=applyFilters?this.query:this.appliedQuery,status=applyFilters?this.status:this.appliedStatus;
        const scope=applyFilters?this.reviewScope:this.appliedReviewScope;
        if(!this.leave()){await this.render();this.restoreFilters();await this.render();return;}
        await this.task(async()=>{await this.list(page,q,status,scope);this.clearSelection();this.editor=null;this.queueOpen=true;});
        if(this.error){this.restoreFilters();await this.render();}
    }
    async refresh() {
        if(!this.leave())return;
        const browsing=this.browsing;
        await this.task(async()=>{await this.bootstrap();await this.list(this.rows.page);this.editor=null;if(this.selected)this.accept(this.demo?this.selected:await this.call('detail',{id:this.selected.id}),this.demo);this.queueOpen=browsing;});
    }
    accept(row:any,isDemo=false) {
        this.nextLoadFailed=false;this.contextRefreshFailed=false;this.evaluationError=false;this.holdOpen=false;this.cardGesture=null;
        this.selected=row;this.reviewStarted=this.tab==='review';this.demo=isDemo;this.recheckMode=false;this.editor=null;this.qaPicker=false;this.managementOpen=false;this.reveal=false;this.queueOpen=false;this.evidenceBlocks=this.parseEvidence(row);if(!isDemo)this.started=true;
        this.choice=row.decision==='PENDING'?'':row.decision;this.reason=(row.reason||'').replace(/\r\n?/g,'\n');
        if(this.reason===this.decisionReason(this.choice))this.reason='';
        this.reasonTag=this.reasonOptions.find(tag=>this.reason===tag || this.reason.startsWith(tag+'\n')) || '';
        if(this.reasonTag)this.reason=this.reason.slice(this.reasonTag.length).replace(/^\n/,'');
        this.memoOpen=false;
        this.baseline=JSON.stringify([this.choice,this.reasonTag,this.reason]);
    }
    async open(row:any) {
        if(!this.leave())return;
        if(this.tab==='dataset'&&this.selected?.id===row.id) {
            const remaining=this.rows.items;
            const target=remaining.find((item:any)=>item.id===row.id)||remaining[Math.min(this.resultPosition,remaining.length-1)];
            this.clearSelection();this.evidenceOpen=false;
            await this.focus(target?'result-item-'+target.id:'pair-search');return;
        }
        const position=Math.max(0,this.resultItems.findIndex((item:any)=>item.id===row.id));
        await this.task(async()=>{this.accept(await this.call('detail',{id:row.id}));this.resultPosition=position;});
        if(this.error)return;
        if(this.tab==='dataset') {
            await this.render();
            const element=document.getElementById('result-item-'+row.id);
            element?.scrollIntoView({block:'start',behavior:'instant'});element?.focus({preventScroll:true});
        } else await this.focus('question-heading');
    }
    async beginRecheck() {
        if(this.busy || this.dead || !this.selected || this.selected.decision==='PENDING' || !this.permissions.can_write || !this.leave())return;
        this.recheckMode=true;this.choice='';this.reasonTag='';this.reason='';this.memoOpen=false;this.reveal=false;
        this.baseline=JSON.stringify([this.choice,this.reasonTag,this.reason]);
        await this.focus('question-heading');
    }
    async cancelRecheck() {
        if(!this.leave())return;
        this.accept(this.selected);await this.focus('question-heading');
    }
    recordedReason(row:any) {
        if(row.evaluation?.reason_recorded===false || !row.reason || row.reason===this.decisionReason(row.decision))return '구체적인 판단 이유 미기록';
        return row.reason;
    }
    async example() {
        if(!this.leave())return;
        this.tab='review';this.error='';this.notice='';
        this.accept({
            id:'demo',title:'문헌 근거를 충실히 반영한 응답 고르기',version:0,decision:'PENDING',reason:'',history:[],
            prompt:'아래 예시 문헌에서 중재의 효과와 연구의 한계를 어떻게 요약할 수 있나요?',
            source:'화면 체험용 합성 문헌 · 예시 1쪽',
            evidence:'이 예시 연구에서는 중재군의 증상 점수가 비교군보다 감소하였다. 다만 표본 수가 적고 추적 기간이 짧아 결과를 일반화하기 어렵다. 추가 연구가 필요하다.',
            response_a:'예시 문헌에서는 중재군의 증상 점수가 비교군보다 감소했다고 보고했습니다. 다만 표본 수가 적고 추적 기간이 짧아 일반화에 한계가 있으며, 추가 연구가 필요합니다.',
            response_b:'이 중재는 모든 대상자에게 효과가 있으며, 장기간 사용해도 같은 결과를 기대할 수 있습니다.',
            model_a:'예시 응답 A',model_b:'예시 응답 B'
        },true);
        await this.focus('question-heading');
    }
    async choose(id:string) {
        if(this.busy || this.dead)return;
        this.choice=id;
        if(!this.reasonOptions.includes(this.reasonTag))this.reasonTag='';
        await this.render();
    }
    async chooseReason(value:string) {if(this.busy || this.dead)return;this.reasonTag=this.reasonTag===value?'':value;await this.render();}
    cardPointerStart(event:PointerEvent) {
        this.cardGesture={id:event.pointerId,x:event.clientX,y:event.clientY,pair:this.selected?.id,version:this.selected?.version,voteVersion:this.selected?.vote_version??0,moved:this.busy||!this.canEvaluate};
    }
    cardPointerMove(event:PointerEvent) {
        const point=this.cardGesture;
        if(point&&point.id===event.pointerId&&Math.hypot(event.clientX-point.x,event.clientY-point.y)>6)point.moved=true;
    }
    cancelCardGesture() {if(this.cardGesture)this.cardGesture.moved=true;}
    async selectCard(event:MouseEvent,id:string) {
        const gesture=this.cardGesture;this.cardGesture=null;
        if(!this.canEvaluate||this.busy||this.dead||!['A','B'].includes(id)||event.button!==0||event.detail>1||
            event.altKey||event.ctrlKey||event.metaKey||event.shiftKey)return;
        const target=event.target as HTMLElement,card=event.currentTarget as HTMLElement;
        if(target.closest?.('a,input,textarea,select,[contenteditable="true"],button:not(.card-choice)'))return;
        if(event.detail===0) {
            if(!target.closest?.('.card-choice'))return;
        } else {
            if(gesture&&(gesture.moved||gesture.pair!==this.selected.id||gesture.version!==this.selected.version||gesture.voteVersion!==(this.selected.vote_version??0)))return;
            const selection=window.getSelection?.();
            if(selection?.rangeCount&&selection.toString()&&selection.getRangeAt(0).intersectsNode(card))return;
            const body=target.closest?.('.response-body') as HTMLElement;
            if(body&&body.scrollHeight>body.clientHeight&&body.offsetWidth>body.clientWidth&&
                event.clientX>=body.getBoundingClientRect().left+body.clientLeft+body.clientWidth)return;
        }
        await this.selectAndSave(id);
    }
    async selectAndSave(id:string) {
        if(this.busy || this.dead || !this.canEvaluate || !this.decisionReason(id))return;
        if(!this.recheckMode && this.selected.decision===id && !this.dirty)return;
        const previous=this.choice;this.choice=id;
        if(this.reasonTag&&!this.reasonOptions.includes(this.reasonTag)) {
            this.memoOpen=true;
            this.error='선택한 판정에 맞는 이유를 골라 주세요.';this.evaluationError=true;
            await this.focus('evaluation-reason-tag');return;
        }
        if(id==='HOLD'&&!this.effectiveReason) {
            if(!this.holdOpen)this.holdPreviousChoice=previous;
            this.holdOpen=true;this.error='';this.evaluationError=false;
            await this.focus('hold-reason-0');return;
        }
        this.holdOpen=false;
        if(this.effectiveReason.length>2000) {
            this.error='판단 메모를 2,000자 이내로 줄여 주세요.';this.memoOpen=true;
            await this.focus('evaluation-reason');return;
        }
        await this.saveEvaluation();
    }
    async holdWithReason(value:string) {
        if(this.busy||this.dead||!this.canEvaluate||!this.holdOpen||!this.reasonGroups.HOLD.includes(value))return;
        this.reasonTag=value;this.holdOpen=false;await this.selectAndSave('HOLD');
    }
    async writeHoldMemo() {
        if(this.busy||!this.holdOpen)return;
        this.holdOpen=false;this.memoOpen=true;await this.focus('evaluation-reason');
    }
    async cancelHold() {
        if(this.busy||!this.holdOpen)return;
        this.choice=this.holdPreviousChoice;this.holdOpen=false;await this.focus('decision-hold');
    }
    get evaluationHint() {
        if(this.evaluationPhase==='saving')return '판정을 저장하는 중입니다.';
        if(this.evaluationPhase==='next')return '저장 완료 · 다음 문항을 불러오는 중입니다.';
        if(this.evaluationPhase==='refresh')return '저장 완료 · 현황을 갱신하는 중입니다.';
        if(this.demo)return '시연 선택은 서버에 저장되지 않습니다.';
        if(this.recheckMode)return '재검토 결과와 이전 판정을 함께 기록합니다.';
        if(this.tab==='dataset')return '다시 선택하면 내 평가가 수정됩니다.';
        return this.selected?.decision==='PENDING'?'카드를 선택하면 저장하고 다음 문항으로 이어집니다.':'선택은 저장되었습니다.';
    }
    async pendingWithStats() {
        const reads=await Promise.allSettled([
            this.bootstrap(),
            this.call('list',{q:this.appliedQuery,status:'PENDING',page:1,review_scope:this.appliedReviewScope})
        ]);
        if(reads[0].status==='rejected')throw reads[0].reason;
        if(reads[1].status==='rejected')throw reads[1].reason;
        return reads[1].value;
    }
    async saveEvaluation() {
        if(!this.canSave || this.busy || this.dead || !this.canEvaluate)return;
        const id=this.selected.id,version=this.selected.version,vote_version=this.selected.vote_version??0,decision=this.choice,reason=this.effectiveReason,isDemo=this.demo;
        const recheck=this.recheckMode,changed=recheck&&this.selected.decision!==decision;
        const advance=this.tab==='review'&&!recheck&&this.selected.decision==='PENDING';
        const returnFocus=document.activeElement?.id==='save-evaluation-memo'?'memo-toggle':decision==='A'?'answer-a-heading':decision==='B'?'answer-b-heading':'decision-heading';
        if(changed&&!window.confirm('이전 판정은 '+this.label(this.selected.decision)+'입니다. 이번 '+this.label(decision)+' 판정으로 변경할까요? 이전 판정과 사유는 이력에 보존됩니다.'))return;
        const criteria={version:'dpo-evidence-v1',reason_tag:this.reasonTag,memo:this.reason.trim(),recheck,confirm_change:changed};
        let advanced=false;this.evaluationPhase='saving';this.nextLoadFailed=false;this.contextRefreshFailed=false;
        await this.task(async()=>{
            if(isDemo) {
                const row={...this.selected,decision,reason,version:version+1};
                this.accept(row,true);this.notice='시연 선택을 반영했습니다. 서버에는 저장하지 않았습니다.';
                return;
            }
            const saved=await this.call('evaluate',{id,version,vote_version,decision,reason,criteria:JSON.stringify(criteria)});
            this.sessionEvaluated.add(saved.id);
            this.lastEvaluation={id:saved.id,decision:saved.decision,prompt:saved.prompt};
            this.accept(saved);this.evaluationPhase=advance?'next':'refresh';await this.render();
            this.notice=this.label(decision)+'로 저장했습니다.';
            try {
                if(!advance) {
                    await this.bootstrap();await this.list(this.rows.page);
                    this.notice=recheck?'재검토를 저장했습니다.'+(changed?' 이전 판정은 이력에 보존됩니다.':' 이전 판정과 같습니다.'):'내 평가를 수정했습니다. 이전 기록은 이력에 보존됩니다.';
                    return;
                }
                const pending=await this.pendingWithStats();
                if(pending.items.length) {
                    const next=await this.call('detail',{id:pending.items[0].id});
                    this.setListing(pending,this.appliedQuery,'PENDING');this.accept(next);advanced=true;
                    this.notice=this.label(decision)+'로 저장했습니다. 다음 평가 대기 자료입니다.';
                } else {
                    await this.list(1,'','PENDING','all');this.clearSelection();this.reviewStarted=false;
                    this.notice='모든 문항의 평가를 마쳤습니다.';
                }
            } catch(e:any) {
                this.nextLoadFailed=advance;this.contextRefreshFailed=!advance;this.evaluationError=true;
                this.notice=advance?'평가는 저장했습니다. 다음 자료를 불러오지 못했습니다.':'수정은 저장했습니다. 현황을 갱신하지 못했습니다. 다시 저장할 필요는 없습니다.';
                this.error=e.message;
            }
        });
        this.evaluationPhase='';
        if(this.error){this.evaluationError=true;await this.focus('evaluation-feedback');}
        else if(advanced)await this.focus('question-heading');
        else {await this.render();document.getElementById(this.selected?returnFocus:'dpo-heading')?.focus({preventScroll:true});}
    }
    async retryEvaluationContext() {
        if(this.busy||this.dead||!this.contextRefreshFailed||!this.leave())return;
        await this.task(async()=>{
            await this.bootstrap();await this.list(this.rows.page);this.contextRefreshFailed=false;
            this.notice='저장된 평가와 현황을 확인했습니다.';
        });
        if(this.error){this.evaluationError=true;await this.focus('evaluation-feedback');}
    }
    async reset() {
        if(this.busy || !window.confirm('현재 선호 평가를 해제하고 평가 대기로 돌릴까요? 변경 이력은 보존됩니다.'))return;
        await this.task(async()=>{
            if(this.demo) {
                this.accept({...this.selected,decision:'PENDING',reason:'',version:this.selected.version+1},true);
                this.notice='시연 선택을 초기화했습니다.';
                return;
            }
            const resetRow=await this.call('reset',{id:this.selected.id,version:this.selected.version,vote_version:this.selected.vote_version??0,reason:'평가 화면에서 선호 평가 해제'});
            this.sessionEvaluated.delete(resetRow.id);
            if(this.lastEvaluation?.id===resetRow.id)this.lastEvaluation=null;
            this.accept(resetRow);
            this.notice='평가 대기로 변경했습니다.';
            try {await this.bootstrap();await this.list(this.rows.page);}
            catch(e:any){this.notice='평가 대기로 변경했습니다. 목록을 불러오지 못했습니다. 새로고침해 주세요.';this.error=e.message;}
        });
    }
    qaGroupLabel(id:string) {return this.qaGroups.find(g=>g.id===id)?.label || 'QA';}
    async startQA() {
        if(this.busy||this.dead||!this.permissions.can_manage||!this.leave())return;
        if(this.selected)this.accept(this.selected,this.demo);
        this.preparationTab=this.tab;this.editor=null;this.tab='review';this.qaPicker=true;this.qaQuery='';this.qaGroup='';
        await this.searchQA();
        if(!this.error)await this.focus('qa-picker-heading');
    }
    async searchQA(page=1,applyFilters=true) {
        if(this.busy||this.dead||!this.permissions.can_manage)return;
        const q=applyFilters?this.qaQuery:this.appliedQaQuery,group=applyFilters?this.qaGroup:this.appliedQaGroup;
        await this.task(async()=>{
            const rows=await this.call('qa_list',{q,group,page});
            this.qaRows=rows;this.appliedQaQuery=q;this.appliedQaGroup=group;
        });
        this.qaQuery=this.appliedQaQuery;this.qaGroup=this.appliedQaGroup;await this.render();
    }
    async openExistingQA(row:any) {
        if(!row.existing_pair?.id || !this.leave())return;
        await this.task(async()=>{
            const detail=await this.call('detail',{id:row.existing_pair.id});
            if(this.adminPreparation) {this.accept(detail);this.preparePairEditor();return;}
            const status=detail.decision==='PENDING'?'PENDING':'EVALUATED';
            const scope=status==='PENDING'?this.reviewTabScope:'all';
            const rows=await this.call('list',{q:'',status,page:1,review_scope:scope});
            this.tab=status==='PENDING'?'review':'dataset';this.setListing(rows,'',status,scope);this.accept(detail);
        });
        if(!this.error)await this.focus('question-heading');
    }
    async useQA(row:any) {
        if(this.busy||this.dead||!this.permissions.can_manage)return;
        await this.task(async()=>{
            const seed=await this.call('qa_detail',{qa_id:row.qa_id});
            this.editor={id:this.uuid(),version:0,title:seed.title,prompt:seed.prompt,response_a:seed.response_a,response_b:'',
                model_a:seed.model_a,model_b:'',source:seed.source,evidence:seed.evidence,origin:seed.origin};
            this.invalidateBReview();this.editorBaseline=JSON.stringify(this.editor);this.qaPicker=false;
        });
        if(!this.error)await this.focus('editor-heading');
    }
    get guideReady() {return !!this.guide?.version && typeof this.guide?.prompt==='string' && !!this.guide.prompt.trim();}
    get comparisonInput() {
        if(!this.editor || !this.guideReady)return '';
        return this.guide.prompt+
            (this.editor.origin?.qa_id?'\n\n[원본 QA 식별자]\n'+this.editor.origin.qa_id:'')+
            '\n\n[질문]\n'+this.editor.prompt+'\n\n[문헌 출처]\n'+this.editor.source+'\n\n[문헌 근거]\n'+this.editor.evidence;
    }
    async copyComparisonInput() {
        this.error='';this.notice='';
        if(!this.guideReady){this.error='비교 답변 작성 기준을 불러오지 못해 복사할 수 없습니다. 기준을 확인한 뒤 다시 시도해 주세요.';await this.render();return;}
        try {
            if(navigator.clipboard?.writeText)await navigator.clipboard.writeText(this.comparisonInput);
            else {
                const input=document.createElement('textarea');input.value=this.comparisonInput;
                input.style.position='fixed';input.style.opacity='0';document.body.appendChild(input);
                try {input.select();if(!document.execCommand('copy'))throw new Error('copy');}
                finally {input.remove();}
            }
            this.notice='작성 기준 '+this.guide.version+'과 질문·문헌 근거를 복사했습니다. 작성한 답변만 B에 붙여 넣으세요.';
        } catch(e) {this.error='자동 복사를 사용할 수 없습니다. ‘비교용 입력 확인’을 펼쳐 내용을 직접 복사해 주세요.';}
        await this.render();
    }
    async newPair() {
        if(this.busy||this.dead||!this.permissions.can_manage||!this.leave())return;
        if(!this.qaPicker)this.preparationTab=this.tab;
        if(this.selected)this.accept(this.selected,this.demo);
        this.tab='review';this.error='';this.notice='';
        this.qaPicker=false;this.editor={id:this.uuid(),version:0,title:'',prompt:'',response_a:'',response_b:'',model_a:'',model_b:'',source:'',evidence:''};
        this.invalidateBReview();this.editorBaseline=JSON.stringify(this.editor);await this.focus('pair-title');
    }
    private preparePairEditor() {
        this.preparationTab=this.tab;this.accept(this.selected);
        const e:any={};for(const k of ['id','version','title','prompt','response_a','response_b','model_a','model_b','source','evidence'])e[k]=this.selected[k]??'';
        if(this.selected.origin)e.origin=this.selected.origin;
        this.editor=e;this.invalidateBReview();this.editorBaseline=JSON.stringify(e);
    }
    async editPair() {
        if(this.busy||this.dead||!this.permissions.can_manage||this.demo||!this.selected||!this.leave())return;
        this.preparePairEditor();await this.focus('pair-title');
    }
    async cancelEditor() {
        if(!this.leave())return;
        this.editor=null;this.qaPicker=false;
        if(this.adminPreparation&&this.router) {this.clearSelection();await this.router.navigate(['/admin'],{queryParams:{tab:'reviews',view:'results'}});return;}
        this.tab=this.preparationTab;this.reviewStarted=false;this.clearSelection();await this.focus('dpo-heading');
    }
    bContent(value:any) {
        return JSON.stringify(['prompt','response_a','response_b','source','evidence','origin'].map(k=>value?.[k]??''));
    }
    get needsBReview() {
        if(!this.editor)return false;
        if(!this.editor.version)return true;
        try{return this.bContent(this.editor)!==this.bContent(JSON.parse(this.editorBaseline));}
        catch{return true;}
    }
    get bInspectionCurrent() {return !!this.bInspection && this.bInspectionSnapshot===this.bContent(this.editor);}
    get bReadyToSave() {
        return !this.needsBReview || (this.bInspectionCurrent && this.bInspection.can_review &&
            this.bQuestionChecked && this.bEvidenceChecked && (!this.bInspection.signals.length || !!this.bExceptionNote.trim()));
    }
    get pairSubmitLabel() {
        if(this.busy)return '처리 중…';
        return this.needsBReview&&!this.bInspectionCurrent?'B 점검하기':'확인 후 저장';
    }
    invalidateBReview() {
        this.bInspection=null;this.bInspectionSnapshot='';this.bQuestionChecked=false;this.bEvidenceChecked=false;this.bExceptionNote='';
    }
    async bContentChanged() {this.invalidateBReview();await this.render();}
    async inspectB() {
        if(!this.editor||this.busy||this.dead||!this.permissions.can_manage)return;
        this.invalidateBReview();
        await this.task(async()=>{
            const snapshot=this.bContent(this.editor);
            const result=await this.call('inspect_b',{data:JSON.stringify(this.editor)});
            if(snapshot!==this.bContent(this.editor))throw Error('입력 내용이 변경되었습니다. B를 다시 점검해 주세요.');
            this.bInspection=result;this.bInspectionSnapshot=snapshot;
        });
        if(!this.error)await this.focus('b-review-heading');
    }
    async savePair() {
        if(!this.editor||this.busy||this.dead||!this.permissions.can_manage)return;
        if(!['title','prompt','response_a','response_b'].every(k=>this.editor[k]?.trim())){this.error='제목, 질문, 응답 A와 B를 모두 입력해 주세요.';await this.focus('pair-title');return;}
        if(this.editor.response_a.trim()===this.editor.response_b.trim()){this.error='응답 A와 B가 같습니다. 비교할 서로 다른 응답을 입력해 주세요.';await this.focus('response-b');return;}
        if(this.needsBReview && !this.bInspectionCurrent){await this.inspectB();return;}
        if(!this.bReadyToSave){this.error='표시된 표현과 질문·근거를 확인한 뒤 저장해 주세요.';await this.focus('b-review-heading');return;}
        const payload={...this.editor};let savedForAdmin=false;
        if(this.needsBReview)payload.b_review={fingerprint:this.bInspection.fingerprint,question_checked:this.bQuestionChecked,
            evidence_checked:this.bEvidenceChecked,exception_note:this.bExceptionNote.trim()};
        await this.task(async()=>{
            const saved=await this.call('save',{data:JSON.stringify(payload)});
            if(saved.decision==='PENDING'){
                this.sessionEvaluated.delete(saved.id);
                if(this.lastEvaluation?.id===saved.id)this.lastEvaluation=null;
            }
            this.accept(saved);this.tab='review';
            this.notice='평가 자료를 저장했습니다.';
            if(this.adminPreparation&&this.router) {savedForAdmin=true;return;}
            try {await this.bootstrap();await this.list(1,'','PENDING',this.reviewTabScope);}
            catch(e:any){this.notice='응답쌍을 저장했습니다. 목록을 불러오지 못했습니다. 새로고침해 주세요.';this.error=e.message;}
        });
        if(savedForAdmin) {
            try {
                if(!await this.router.navigate(['/admin'],{queryParams:{tab:'reviews',view:'results'}}))this.error='자료는 저장했습니다. 관리 화면으로 이동하지 못했습니다.';
            } catch {this.error='자료는 저장했습니다. 관리 화면으로 이동하지 못했습니다.';}
            if(this.error)await this.render();
            return;
        }
        if(!this.error)await this.focus('question-heading');
    }
    async toggleModels() {this.reveal=!this.reveal;await this.render();}
}

export default PageDpoComponent;